import React from 'react';
import ReactionBar from '../../components/Community/ReactionBar/ReactionBar';

export const renderReactionBar = (
    contentHash,
    location = 'singleContent',
    className = ''
) => (
    <ReactionBar hash={contentHash} location={location} className={className} />
);
